import { render, staticRenderFns } from "./AmazingProductBox.vue?vue&type=template&id=aee5d0f8&scoped=true&"
import script from "./AmazingProductBox.vue?vue&type=script&lang=js&"
export * from "./AmazingProductBox.vue?vue&type=script&lang=js&"
import style0 from "./AmazingProductBox.vue?vue&type=style&index=0&id=aee5d0f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee5d0f8",
  null
  
)

export default component.exports